import React, { useCallback } from 'react';
import { Label } from '../../components/ui/label';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import LabelTooltip from '../../components/LabelTooltip';
import FormField from '../../components/FormField';
import constants from '../../commonUtils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { getExtPincodeFromMaster } from '../../store/extractions/action';

const OtherDetailsSection = ({ extractionData, errors, handleInputChange, metaDataLoading }) => {
    const dispatch = useDispatch();
    const { pincodeOptions, pincodeLoading } = useSelector((state) => state.Extractions);

    // Fires on every debounced keystroke — fetches suggestions from the in-memory cache
    const handlePincodeChange = useCallback((field, value) => {
        const val = value !== undefined ? value : field;
        // Prevent continuous calls if the input exactly matches the selected pincode
        if (val && val.length >= 2 && val !== extractionData?.pincode) {
            dispatch(getExtPincodeFromMaster(val));
        }
    }, [dispatch, extractionData?.pincode]);

    return (
        <div className={`space-y-6 transition-all duration-300 ease-in-out overflow-hidden`}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                <Label htmlFor="approxStartingPrice" className="font-bold text-gray-500">
                    <span>Approximate Starting Price *</span>
                    <LabelTooltip
                        Icon={InformationCircleIcon}
                        content={
                            <span className="ml-auto max-w-[400px]">
                                {constants.extraction.tooltipTexts?.approxStartingPrice}
                            </span>
                        }
                    />
                </Label>
                <div className="md:col-span-2">
                    <FormField
                        fieldKey="approxStartingPrice"
                        label="Approximate Starting Price"
                        hideLabel={true}
                        type="text"
                        required={true}
                        value={extractionData?.approxStartingPrice}
                        error={errors?.approxStartingPrice}
                        handleChange={handleInputChange}
                        disabled={metaDataLoading}
                    />
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                <Label htmlFor="pincode" className="font-bold text-gray-500">
                    <span>Pincode *</span>
                    <LabelTooltip
                        Icon={InformationCircleIcon}
                        content={
                            <span className="ml-auto max-w-[400px]">
                                {constants.extraction.tooltipTexts?.pincode}
                            </span>
                        }
                    />
                </Label>
                <div className="md:col-span-2">
                    <FormField
                        fieldKey="pincode"
                        label="Pincode"
                        hideLabel={true}
                        type="autocomplete"
                        required={true}
                        options={pincodeOptions}
                        value={extractionData?.pincode}
                        error={errors?.pincode}
                        handleChange={handleInputChange}
                        onChange={handlePincodeChange}
                        disabled={metaDataLoading || pincodeLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default OtherDetailsSection;